import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    orgCode: Yup.string().required(requiredMessage),
    customerGroupCode: Yup.string().required(requiredMessage),
    customerGroupName: Yup.string(),
    typeCode: Yup.number(),
    companyType: Yup.string(),
    subscriptionScheme: Yup.array().required(requiredMessage),
    subscriptionType: Yup.string(),
    dataRange: Yup.string(),
  })
}

export default makeValidationSchema
